// @generated by protoc-gen-connect-query v2.0.0 with parameter "import_extension=js"
// @generated from file services/ontology/api/temporal.proto (package gx.ontology.api, syntax proto3)
/* eslint-disable */

import { TemporalService } from "./temporal_pb.js";

/**
 * @generated from rpc gx.ontology.api.TemporalService.TriggerOntologyProjectSyncWorkflow
 */
export const triggerOntologyProjectSyncWorkflow = TemporalService.method.triggerOntologyProjectSyncWorkflow;
